export default "__VITE_ASSET__pxX8P$8h__"